/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ToolTipButton from 'components/common/TooltipButton';
import PageLoader from 'components/custom/animate-component/PageLoader';
import { useState } from 'react';
import { Card, Col, Modal, Row } from 'react-bootstrap';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { getSettlementModalStatus } from 'helpers/status-badge';
import { formatDate } from 'services/utils';
import { Button, Table, Form } from 'react-bootstrap';
import { currencyFormat } from 'helpers/utils';
import AmountModal from './AmountModal';
const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;
    margin-left: auto;
    max-width: 1200px; /* Full width */
    width: 100%;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

const CreateSettlementModal = ({
  show,
  handleClose,
  data,
  handleLoading,
  refreshData,
  checkDiffTab = 'challanDetail',
  modalType,
  handleReject,
  handleApproval,
  tds_percent
}) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const [paymentDetail, setPaymentDetail] = useState({});
  const handlePayment = value => {
    setShowPaymentModal(true);
    setPaymentDetail(value);
  };
  return (
    <CustomModal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Row style={{ maxHeight: 'calc(100vh - 50px)' }}>
        <Col xs={12} lg={12} className="rounded-3">
          <div className="bg-white rounded-3 h-100 d-flex flex-column">
            <Modal.Header
              className="border-0 position-relative pb-0 end-0 dark__text-white px-4 border-bottom d-flex justify-content-between align-items-start"
              closeButton={false}
            >
              <div className="mb-2">
                <h4 className="modal-title mb-2 text-1000">
                  {modalType === 'pending settlement' && 'Pending Settlement'}
                  {modalType === 'create settlement' && 'Create Settlement'}
                  {modalType === 'checking' && 'Checking Settlement'}
                  {modalType === 'View' && 'View Settlement'}
                  {modalType === 'approval' && 'Approval Settlement'}
                  {modalType === 'payment' &&
                    data.retrieve !== 'retrieve' &&
                    'Payment Settlement'}
                  {data.retrieve === 'retrieve' && 'Retrieve Payment'}
                </h4>
              </div>

              <div>
                <ToolTipButton
                  onClick={handleClose}
                  size="sm"
                  variant="phoenix-secondary"
                  label="Close modal"
                  className="ms-2"
                >
                  <FontAwesomeIcon icon={faX} />
                </ToolTipButton>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 pb-0">
              <>
                {/* <div className="border border-1 p-1 rounded-2 mb-1 card w-75 mx-auto"> */}
                <div className="m-5">
                  <Row className="  d-flex justify-content-between">
                    <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4}>
                      <Card className="border-300 ">
                        <Card.Body className="p-0">
                          <div className="table-responsive">
                            <table className="table table-bordered mb-0">
                              <tbody>
                                <tr>
                                  <td className="w-50 pt-1 ps-3">
                                    <small className="text-700 text-primary">
                                      Trucker Name
                                    </small>
                                    <br />
                                    <span className="fw-bold">
                                      {data.truckerInformation.truckerName ||
                                        '__'}
                                    </span>
                                  </td>
                                  <td className="w-50 pt-1 ps-3">
                                    <small className="text-700 text-primary">
                                      Contact Number
                                    </small>
                                    <br />
                                    <span className="fw-bold">
                                      {data.truckerInformation.contactNo ||
                                        '__'}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="w-50 pt-1 ps-3">
                                    <small className="text-700 text-primary">
                                      PAN No
                                    </small>
                                    <br />
                                    <span className="fw-bold">
                                      {data.truckerInformation.panNo || '__'}
                                    </span>
                                  </td>
                                  <td className="w-50 pt-1 ps-3">
                                    <small className="text-700 text-primary">
                                      Bank Name
                                    </small>
                                    <br />
                                    <span className="fw-bold">
                                      {data.truckerInformation.bankName || '__'}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="w-50 pt-1 ps-3">
                                    <small className="text-700 text-primary">
                                      Account No
                                    </small>
                                    <br />
                                    <span className="fw-bold">
                                      {data.truckerInformation.bankAccountNo ||
                                        '__'}
                                    </span>
                                  </td>
                                  <td className="w-50 pt-1 ps-3">
                                    <small className="text-700 text-primary">
                                      IFSC Code
                                    </small>
                                    <br />
                                    <span className="fw-bold">
                                      {data.truckerInformation.ifscCode || '__'}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    {modalType !== 'create settlement' && (
                      <Col
                        className="mt-md-0 mt-2"
                        xs={12}
                        sm={6}
                        md={5}
                        lg={5}
                        xl={5}
                        xxl={5}
                      >
                        <Card className="border-300">
                          <Card.Body className="p-0">
                            <div className="table-responsive">
                              <table className="table table-bordered mb-0">
                                <tbody>
                                  <tr className="">
                                    <td className="fw-bold fs-9 bg-light">
                                      Voucher Date
                                    </td>
                                    <td className="fs-9">
                                      {formatDate(
                                        data?.settlement_date,
                                        'DD MMM YYYY'
                                      )}
                                    </td>
                                  </tr>

                                  <tr className="">
                                    <td className="fw-bold fs-9 bg-light">
                                      Voucher Status
                                    </td>
                                    <td className="fs-9">
                                      {
                                        getSettlementModalStatus(
                                          data?.settlement_status
                                        )?.label
                                      }
                                    </td>
                                  </tr>

                                  <tr className="">
                                    <td className="fw-bold fs-9 bg-light">
                                      Voucher No / Challan No
                                    </td>
                                    <td className="fs-9">
                                      {data?.settelment_no}
                                    </td>
                                  </tr>

                                  <tr className="">
                                    <td className="fw-bold fs-9 bg-light">
                                      <strong>Route Name:</strong>
                                    </td>
                                    <td>
                                      {[
                                        ...new Map(
                                          data?.challans?.map(item => [
                                            `${item.from_name}-${item.to_name}`,
                                            item
                                          ])
                                        ).values()
                                      ].map((item, index) => (
                                        <div
                                          className="fs-9"
                                          key={`route-${index}`}
                                        >
                                          {item.from_name} To {item.to_name}
                                        </div>
                                      ))}
                                    </td>
                                  </tr>

                                  <tr className="">
                                    <td className="fw-bold fs-9 bg-light">
                                      <strong>Do Number:</strong>
                                    </td>
                                    <td>
                                      {[
                                        ...new Map(
                                          data?.challans?.map(item => [
                                            item.do_number,
                                            item
                                          ])
                                        ).values()
                                      ].map((item, index, arr) => (
                                        <span
                                          className="fs-9"
                                          key={`do-${index}`}
                                        >
                                          {item.do_number}
                                          {index !== arr.length - 1 && ','}
                                        </span>
                                      ))}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    )}
                  </Row>
                </div>

                <div className="mt-4">
                  <div className="table-responsive">
                    <Table bordered className="mt-3">
                      <thead className="bg-light">
                        <tr>
                          <th className="px-3 text-nowrap">S. No</th>
                          <th className="px-3 text-nowrap">Challan Date</th>
                          <th className="px-3 text-nowrap">Challan No</th>
                          <th className="px-3 text-nowrap">Vehicle No</th>
                          <th className="px-3 text-nowrap">Rate</th>
                          <th className="px-3 text-nowrap">Dis Qty</th>
                          <th className="px-3 text-nowrap">Rec Qty</th>
                          <th className="px-3 text-nowrap">Minimum Qty</th>
                          <th className="px-3 text-nowrap">Freight Amt</th>
                          <th className="px-3 text-nowrap">Short Qty</th>
                          <th className="px-3 text-nowrap">Short Amount</th>
                          <th className="px-3 text-nowrap">Net Freight</th>
                          <th className="px-3 text-nowrap">Fuel Amount</th>
                          <th className="px-3 text-nowrap">Cash Advance</th>
                          <th className="px-3 text-nowrap">Loading Expenses</th>
                          <th className="px-3 text-nowrap">Penalty Charges</th>
                          <th className="px-3 text-nowrap">Total Deduction</th>
                          <th className="px-3 text-nowrap">Balance Amt</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.challans?.map((row, index) => (
                          <tr key={index}>
                            <td className="px-3 text-nowrap">{index + 1}</td>
                            <td className="px-3 text-nowrap">
                              {row.challan_date}
                            </td>
                            <td className="px-3 text-nowrap">
                              {row.challan_no}
                            </td>
                            <td className="px-3 text-nowrap">
                              {row.vehicle_number}
                            </td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.rate)}
                            </td>
                            <td className="px-3 text-nowrap">
                              {row.dispatch_quantity}
                            </td>
                            <td className="px-3 text-nowrap">
                              {row.receive_quantity}
                            </td>
                            <td className="px-3 text-nowrap">{row.min_qty}</td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.feight_amt)}
                            </td>
                            <td className="px-3 text-nowrap">
                              {row.short_qty}
                            </td>
                            <td className="px-3 text-nowrap">
                              {row.short_amt}
                            </td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.net_feight_amt)}
                            </td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.fuel_amt)}
                            </td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.cash_advance)}
                            </td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.loading_expenses)}
                            </td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.penalty_amount)}
                            </td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.total_deduction)}
                            </td>
                            <td className="px-3 text-nowrap">
                              {currencyFormat(row.balance_amt)}
                            </td>
                          </tr>
                        ))}

                        <tr className="fw-bold">
                          {/* fw-bold text-center bg-light */}
                          <td colSpan="4" className="text-end text-1100">
                            Total
                          </td>
                          {/* <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) => acc + item?.rate,
                                0
                              )
                            )}
                          </td> */}

                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.rate) || 0),
                                0
                              )
                            )}
                          </td>

                          <td className="text-nowrap">
                            {data?.challans
                              ?.reduce(
                                (acc, item) =>
                                  acc +
                                  (parseFloat(item?.dispatch_quantity) || 0),

                                0
                              )
                              .toFixed(3)}
                          </td>

                          <td className="text-nowrap">
                            {data?.challans
                              ?.reduce(
                                (acc, item) =>
                                  acc +
                                  (parseFloat(item?.receive_quantity) || 0),

                                0
                              )
                              .toFixed(3)}
                          </td>

                          <td className="text-nowrap">
                            {data?.challans
                              ?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.min_qty) || 0),

                                0
                              )
                              .toFixed(3)}
                          </td>
                          {/* <td className="text-nowrap"></td> */}

                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.feight_amt) || 0),
                                0
                              )
                            )}
                          </td>

                          <td className="text-nowrap">
                            {data?.challans
                              ?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.short_qty) || 0),
                                0
                              )
                              .toFixed(3)}
                          </td>

                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.short_amt) || 0),
                                0
                              )
                            )}
                          </td>

                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.net_feight_amt) || 0),
                                0
                              )
                            )}
                          </td>
                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.fuel_amt) || 0),
                                0
                              )
                            )}
                          </td>
                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.cash_advance) || 0),
                                0
                              )
                            )}
                          </td>

                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc +
                                  (parseFloat(item?.loading_expenses) || 0),
                                0
                              )
                            )}
                          </td>

                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.penalty_amount) || 0),
                                0
                              )
                            )}
                          </td>

                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc +
                                  (parseFloat(item?.total_deduction) || 0),
                                0
                              )
                            )}
                          </td>

                          {/* <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) => acc + item?.balance_amt,
                                0
                              )
                            )}
                          </td> */}
                          <td className="text-nowrap">
                            {currencyFormat(
                              data?.challans?.reduce(
                                (acc, item) =>
                                  acc + (parseFloat(item?.balance_amt) || 0),
                                0
                              )
                            )}
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="4" className="text-end text-1100">
                            TDS Charge
                          </td>
                          <td colSpan="13"></td>
                          <td className="text-danger text-nowrap">
                            {currencyFormat(data?.totalTdsCharges || 0)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>

                  <div className="text-end fs-6 text-1000 mt-2">
                    Net Payable : <b>{currencyFormat(data?.final_amount)}</b>
                  </div>
                </div>

                <div className="mt-3"></div>

                {/* {modalType === 'pending settlement' && ( */}
                <div className="px-3 py-4">
                  <Row className="g-3">
                    <Col xs={12} sm={6} md={3}>
                      <strong className="text-1000">Prepared By</strong>
                      <div>{data?.created_by_name}</div>
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <strong className="text-1000">Checked By</strong>
                      <div>{data?.checker_by_name}</div>
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <strong className="text-1000">Approved By</strong>
                      <div>{data?.approved_by_name}</div>
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <strong className="text-1000">Paid By</strong>
                      <div>{data?.paid_by_name}</div>
                    </Col>
                  </Row>
                </div>
                {/* )} */}

                <PageLoader
                  loading={loading}
                  loadingMessage={'Processing...'}
                />
              </>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between flex-wrap">
              {/* Cancel Button on the Left */}
              <Button variant="phoenix-secondary" onClick={handleClose}>
                Cancel
              </Button>

              {/* Action Buttons on the Right */}
              <div className="d-flex gap-2 ">
                {modalType === 'create settlement' && (
                  <Button
                    variant="phoenix-success"
                    onClick={() => handleApproval('accept')}
                  >
                    Create Settlement
                  </Button>
                )}
                {data?.viewOnly !== 'ViewOnly' && (
                  <>
                    {modalType === 'checking' && (
                      <>
                        <Button
                          variant="phoenix-danger"
                          onClick={() => handleReject(data)}
                        >
                          Reject
                        </Button>
                        <Button
                          variant="phoenix-success"
                          onClick={() => handleApproval(data)}
                        >
                          Approve
                        </Button>
                      </>
                    )}

                    {modalType === 'approval' && (
                      <>
                        <Button
                          variant="phoenix-danger"
                          onClick={() => handleReject(data)}
                        >
                          Reject
                        </Button>
                        <Button
                          variant="phoenix-success"
                          onClick={() => handleApproval(data)}
                        >
                          Accept
                        </Button>
                      </>
                    )}
                  </>
                )}

                {modalType === 'payment' && data?.viewOnly !== 'ViewOnly' && (
                  <Button
                    variant="phoenix-primary"
                    onClick={() => handlePayment(data)}
                  >
                    Make Payment
                  </Button>
                )}
                {/* {modalType === 'payment' && (
                  <Button variant="phoenix-primary" onClick={() => {}}>
                    Make Payment
                  </Button>
                )} */}
              </div>
            </Modal.Footer>
          </div>
        </Col>
      </Row>
      {showPaymentModal && (
        <AmountModal
          show={showPaymentModal}
          handleClose={() => setShowPaymentModal(false)}
          // challan={{ ...currentChallan, amount: currentChallan.cash_advance }}
          data={paymentDetail}
          refreshData={refreshData}
          handleLoading={handleLoading}
          closeMianModal={handleClose}
        />
      )}
    </CustomModal>
  );
};

export default CreateSettlementModal;
